import React from 'react'
import {
  AlignItems,
  Bold,
  Box,
  Button,
  Color,
  colors,
  Display,
  FlexDirection,
  Icon,
  JustifyContent,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'
import { CTAs } from '../../config'
import { Sections, trackCTAClick, TrackingActions } from '../../tracking'
import { useIsNDDBannersEnabled } from '@library/delivery-timing'

export type CTAProps = {
  onCTAClick: () => void
  signupCTA: string
}

export function CTA({ onCTAClick, signupCTA }: CTAProps) {
  const {
    ctaNoLockInBoldText,
    ctaNoLockInText,
    ctaNextDayDeliveryBoldText,
    ctaNextDayDeliveryText,
  } = CTAs

  const handleAndTrackCTAClick = () => {
    onCTAClick()
    trackCTAClick(TrackingActions.CLICK_GET_STARTED, Sections.HERO)
  }
  const isNDDBannersEnabled = useIsNDDBannersEnabled()

  return (
    <Box data-testid="cta">
      <Space size={4} />
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
      >
        <Button
          data-testing="homepageAboveTheFoldCTA"
          onClick={handleAndTrackCTAClick}
          width={['min(380px, 92%)', '343px']}
          height="48px"
        >
          {signupCTA}
        </Button>
      </Box>
      <Space size={3} />
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        flexDirection={FlexDirection.Column}
      >
        {isNDDBannersEnabled ? (
          <Text size={2} color={Color.White} textAlign={TextAlign.Center}>
            <Bold>{ctaNoLockInBoldText}</Bold>
            {ctaNoLockInText}
          </Text>
        ) : (
          <>
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              width={['min(380px, 92%)', '350px', '342px']}
              justifyContent={JustifyContent.Center}
            >
              <Icon name="delivery" size={6} style={{ color: colors[Color.White] }} />
              <Space direction="horizontal" size={2} />
              <Text size={2} color={Color.White}>
                <Bold>{ctaNextDayDeliveryBoldText}</Bold>
                {ctaNextDayDeliveryText}
                <sup>†</sup>
              </Text>
            </Box>
            <Space size={1} />
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              width={['min(380px, 92%)', '350px', '342px']}
              justifyContent={JustifyContent.Center}
            >
              <Icon name="play_pause" size={6} style={{ color: colors[Color.White] }} />
              <Space direction="horizontal" size={2} />
              <Text size={2} color={Color.White}>
                <Bold>{ctaNoLockInBoldText}</Bold>
                {ctaNoLockInText}
              </Text>
            </Box>
          </>
        )}
      </Box>
      <Space size={4} />
    </Box>
  )
}
